import type { FC } from "react";

import Female from "@/assets/icons/female";
import Male from "@/assets/icons/male";
import type { Gender } from "@/types/api/patient";

type GenderIconProps = {
  gender: Gender;
};

// TODO: add Other gender icon
const GenderIcon: FC<GenderIconProps> = ({ gender }) => {
  switch (gender) {
    case "MALE":
      return <Male />;
    case "FEMALE":
      return <Female />;
    case "OTHER":
      return <Male />;
  }
};

export default GenderIcon;
